import React from 'react';
import Modal from '@/components/common/Modal/Modal';
import { Footer } from '@/components/common/Modal';
import I18n from '@/modules/i18n';

interface DisableAiFeaturesModalProps {
  bulletKeys: string[];
  onCancel: () => void;
  onConfirm: () => void;
}

const DisableAiFeaturesModal = ({ bulletKeys, onCancel, onConfirm }: DisableAiFeaturesModalProps) => (
  <Modal
    isOpen
    closeModal={onCancel}
    footer={(
      <Footer
        primaryButtonCallback={onConfirm}
        primaryButtonClassName="btn btn--purple"
        primaryButtonSubmit={false}
        primaryButtonText={I18n.t('confirm')}
        secondaryButtonCallback={onCancel}
        wrapperClassName="tw-pr-4 tw-pb-4"
      />
    )}
    headerText={I18n.t('disable_ai_features')}
  >
    <div className="tw-p-4">
      <p className="tw-mb-3">{I18n.t('disable_ai_features_intro')}</p>
      <ul className="tw-list-disc tw-pl-5 tw-space-y-2">
        {bulletKeys.map(key => <li key={key}>{I18n.t(key)}</li>)}
        <li>{I18n.t('disable_ai_features_preserve_bullet')}</li>
      </ul>
    </div>
  </Modal>
);

export default DisableAiFeaturesModal;
